import { Component, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import { NgxLinkifyjsService } from 'ngx-linkifyjs';

import {SlideshowService} from '../slideshow.service';
import {ApiService} from '../../shared/api.service';
import {TeamService} from '../../shared/team.service';
import {Utils} from '../../utils';
import { PermissionsService } from '../../shared/permissions.service';
import { Permissions } from '../../shared/permissions.enum';

@Component({
    selector: 'details-component',
    templateUrl: 'details.component.html'
})
export class DetailsComponent {
    userCanEdit = false;
    user;
    teamService = new TeamService();
    minDate = new Date();
    targetDateControl = new FormControl();
    parentAssignment;
    originalAssignment;
    detailsTabReference = this.utils.rand();
    detailsTabDueDate = this.utils.rand();
    detailsTabTargetPublishDate = this.utils.rand();
    detailsTabAbbr = this.utils.rand();
    detailsTabPageAddDate = this.utils.rand();
    detailsTabPageAddCount = this.utils.rand();

    @ViewChild('notes') notes;
    

    get Permissions() {
        return Permissions;
    }

    constructor(
        public linkService: NgxLinkifyjsService, 
        public slideshow: SlideshowService, 
        private api: ApiService,
        public utils: Utils,
        public permissionsService: PermissionsService,
    ) {
        let user = this.api.getProp('user');
        this.user = user;
        this.userCanEdit = permissionsService.userHasPermission(Permissions.AssignmentDetails);
        this.teamService.loadTeam(this.slideshow.assignment);
        if( this.slideshow.assignment.targetPublishDate ) {
            this.targetDateControl.setValue(new Date(this.slideshow.assignment.targetPublishDate));
        }
        this.targetDateControl.valueChanges.subscribe(value => {
            if( value ) {
                this.slideshow.assignment.targetPublishDate = this.utils.getFormattedDate(new Date(value));
            } else {
                this.slideshow.assignment.targetPublishDate = '';
            }
        });
        this.slideshow.targetPublishDateChange.subscribe(date => {
            const value = this.slideshow.assignment.targetPublishDate ? new Date(this.slideshow.assignment.targetPublishDate) : null;
            this.targetDateControl.setValue(value);
        });
        this.slideshow.commentAdded.subscribe(comment => {
            if( this.notes ) {
                this.notes.comments.unshift(comment);
                this.notes.cdr.markForCheck();
            }
        });
        if(this.slideshow.assignment?.cloneParent) {
            this.api.doAction('post', 'assignments', {
                action: 'get',
                id: this.slideshow.assignment?.cloneParent
            }).subscribe(data => {
                this.parentAssignment = data;
            });
        }
        if(this.slideshow.assignment?.cloneMaster) {
            this.api.doAction('post', 'assignments', {
                action: 'get',
                id: this.slideshow.assignment?.cloneMaster
            }).subscribe(data => {
                this.originalAssignment = data;
            });
        }
    }
    introChange(e, type) {
        let slides = this.slideshow.slides;
        if( slides && slides.length == 0 ) {
            return;
        }
        if( type == 'intro' ) {
            slides[0].intro = e ? 1 : 0;
        }
        if( type == 'outro' && slides.length > 1 ) {
            let last = slides.length - 1;
            slides[last].outro = e ? 1 : 0;
        }
    }
    updateTeam(e, assignment) {
        this.teamService.updateAssignment(e, assignment);
        this.slideshow.updateMessages();
    }
}